import React, { type PropsWithChildren, useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';

import {
  getWebPathname,
  isMarketingWebRoute,
  subscribeWebPathname,
} from '../../core/navigation/webRouteStore';
import { colors } from '../../core/theme/tokens';

/**
 * Full-bleed wrapper around the navigator.
 * Do not change this container’s width when leaving marketing — native-stack
 * screens keep their first measured size, which left a white gutter on /app.
 */
export function WebAppShell({ children }: PropsWithChildren) {
  const [marketing, setMarketing] = useState(() => isMarketingWebRoute(getWebPathname()));

  useEffect(() => {
    return subscribeWebPathname((path) => setMarketing(isMarketingWebRoute(path)));
  }, []);

  return (
    <View style={[styles.outer, marketing && styles.outerMarketing]}>
      <View style={styles.shell}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    height: '100%',
    backgroundColor: '#020617',
  },
  shell: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    height: '100%',
    backgroundColor: colors.background,
  },
  outerMarketing: {
    backgroundColor: colors.background,
  },
});
